<template>
    <div class="summary" :class="elClasses">
        <workflow-layout>
            <template v-slot:header>
                <div>
                    <mds-banner variation="warning" class="summary__banner" v-if="warningBannerConfig.visible" @mds-banner-dismissed="removeWarning">
                        {{ warningBannerConfig.text }}
                    </mds-banner>
                    <workflow-header mwc-id="workflow-header" :component-config="headerConfig" v-on="events"></workflow-header>
                </div>
            </template>
            <home :mwc-id="getMwcIdForChild('chartView')"></home>
        </workflow-layout>
        <header-dialog
            :mwc-id="getMwcIdForChild('headerDialog')"
            :show="showDialog"
            :headerDialogConfig="dialogConfig"
            @dialog-close="dialogCloseHandler"
        ></header-dialog>
        <save-dialog :mwc-id="getMwcIdForChild('saveDialog')" :show="showSaveDialog" @save-event="handleSaveDialog"></save-dialog>
    </div>
</template>

<script>
import MwcSharedMixin from "@/mixins/MwcSharedMixin";
import HypoWorkflowMixin from "@/mixins/HypoWorkflowMixin";
import HeaderConfigMixin from "@/mixins/HeaderConfigMixin";
import WorkflowLayout from "../layouts/WorkflowLayout";
import WorkflowHeader from "hypo-workflow-header/src/WorkflowHeader";
import Home from "../Home/Home";
import HeaderDialog from "./HeaderDialog";
import SaveDialog from "./SaveDialog";
import MdsBanner from "@mds/banner";
import * as types from "@/store/mutation-types";

export default {
    name: "hypo-summary",
    mixins: [MwcSharedMixin, HypoWorkflowMixin, HeaderConfigMixin],
    components: {
        Home,
        WorkflowLayout,
        WorkflowHeader,
        HeaderDialog,
        SaveDialog,
        MdsBanner
    },
    data() {
        return {
            events: {
                continue: () => this.continueHandler(this),
                back: () => this.backHandler(this),
                close: () => this.closeHandler(this),
                closeNotSave: () => this.closeNotSaveHandler(this),
                rename: () => this.renameHandler(this),
                delete: () => this.deleteHandler(this),
                "step-clicked": step => this.handleStepClicked(step)
            },
            warningBannerConfig: {},
            showDialog: false,
            showSaveDialog: false,
            dialogConfig: {}
        };
    },
    beforeMount() {
        this.dialogConfig = this.defaultDialogConfig;
    },
    methods: {
        restoreStepperClass() {
            this.$store.dispatch("stepper/setPortfolioWarningClass", false);
        },
        continueHandler(instance) {
            this.restoreStepperClass();
            this.saveLastStep(this.currentStep.keyString);
            this.$router.push(this.currentStep.nextRoute.route);
        },
        closeHandler(instance) {
            this.restoreStepperClass();
            this.saveLastStep(this.currentStep.keyString);
            this.checkHypoCount();
        },
        closeNotSaveHandler(instance) {
            this.restoreStepperClass();
            this.$store.commit(`hypo/${types.SET_FIRM_SAVED}`, false);
            this.$store.dispatch("clearHypoInput");
            this.$router.push("/type");
        },
        backHandler(instance) {
            this.saveLastStep(this.currentStep.keyString);
            this.$router.push(this.currentStep.previousRoute);
            this.restoreStepperClass();
        },
        renameHandler(instance) {
            this.dialogConfig = this.getDialogConfig("rename", "hypo", null);
            this.showDialog = true;
        },
        deleteHandler(instance) {
            this.dialogConfig = this.getDialogConfig("delete", "hypo", null);
            this.showDialog = true;
        },
        removeWarning() {
            this.warningBannerConfig.visible = false;
            this.restoreStepperClass();
        }
    },
    computed: {
        headerConfig() {
            return {
                leftButton: {
                    type: "secondary",
                    isActive: true,
                    isVisible: true,
                    label: this.$store.state.hypo.firmSaved ? this.getUILabel("COMMON_CLOSE") : this.getUILabel("COMMON_SAVE_AND_CLOSE"),
                    actionTrigger: this.$store.state.hypo.firmSaved ? "closeNotSave" : "close"
                },
                middleButton: {
                    type: "secondary",
                    isActive: true,
                    isVisible: true,
                    label: this.getUILabel("COMMON_PREVIOUS"),
                    actionTrigger: "back"
                },
                rightButton: {
                    type: "primary",
                    isActive: true,
                    isVisible: true,
                    label: this.getUILabel("COMMON_NEXT"),
                    actionTrigger: "continue"
                },
                ...this.getTitleAndStepperConfig()
            };
        },
        elClasses() {
            return {
                [`with-banner`]: this.warningBannerConfig && this.warningBannerConfig.visible
            };
        }
    },
    watch: {
        olderThanOneYearWarning: {
            handler: function() {
                this.$nextTick(() => {
                    const portfolioNamePrefix = this.getUILabel("common_portfolio").toLowerCase();
                    const conjunction = this.getUILabel("and");
                    const portfolioWarning = this.$store.getters["investments/portfolioOlderThanOneYearWarning"](portfolioNamePrefix, conjunction);
                    this.warningBannerConfig = {
                        visible: !!portfolioWarning,
                        text: this.getUILabel("portfolio_more_than_one_year_older_warning", { portfolioWarning: portfolioWarning })
                    };
                    this.$store.dispatch("stepper/setPortfolioWarningClass", !!portfolioWarning);
                });
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss" scoped>
.summary.with-banner {
    ::v-deep .workflow-layout {
        > .mds-layout-grid___hypo {
            padding: 50px 0 55px;
            height: calc(100% - 180px);
        }
        .hypo-workflow-header {
            top: 50px;
        }
    }
}

.summary__banner {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    ::v-deep .mds-banner__body___hypo {
        max-width: 100%;
    }
}
</style>
